import { connect } from 'react-redux';

import companyChargesActionCreators from '_store/_actions/charges';
import paymentGatewaysActionCreators from '_store/_actions/companyPaymentGateways';
import adminPaymentGateways from '_store/_actions/adminPaymentGateways';
import companyTransactionsActionCreators from '_store/_actions/companyTransactions';

import Charge from './Charges';

const mapStateToProps = state => ({
  activeCompany: state.company.activeCompany,

  charges: state.companyCharges.charges,
  totalCharges: state.companyCharges.total,
  adminPaymentGateways: state.adminPaymentGateways.paymentGateways,
  paymentMethods: state.adminPaymentGateways.paymentMethods,
  paymentMethodGateways: state.adminPaymentGateways.paymentMethodGateways,
  isLoadingPaymentGateways: state.adminPaymentGateways.isLoadingPaymentGateways,
  isLoadingPaymentMethods: state.adminPaymentGateways.isLoadingPaymentMethods,

  paymentGateways: state.companyPaymentGateways.paymentGateways,

  recipients: state.companyTransactions.recipients,
  user: state.auth.user,
});

const mapDispatchToProps = {
  onFetchCharges: companyChargesActionCreators.fetchCharges,
  onCreateCharge: companyChargesActionCreators.createCharge,
  onEditCharge: companyChargesActionCreators.updateCharge,
  onDeleteCharge: companyChargesActionCreators.deleteCharge,

  onCreatePaymentGateway: paymentGatewaysActionCreators.createPaymentGateway,
  onUpdatePaymentGateway: paymentGatewaysActionCreators.updatePaymentGateway,
  onDeletePaymentGateway: paymentGatewaysActionCreators.deletePaymentGateway,

  onFetchPaymentGateways: paymentGatewaysActionCreators.fetchPaymentGateways,
  onFetchAdminGateways: adminPaymentGateways.fetchPaymentGateways,
  onFetchPaymentMethods: paymentGatewaysActionCreators.fetchPaymentMethods,

  onFetchContacts: companyTransactionsActionCreators.fetchAllRecipientsSimple,
};

export default connect(mapStateToProps, mapDispatchToProps)(Charge);
